import { TickCircleSVG } from '../../../../svgComponents/tickCircleSVG';
import styles from './EndedPaymentPlanView.module.css';

const EndedPaymentPlanView = () => {
    return (
        <div className={styles.EndedPaymentPlanView}>
            <div className={styles.endedPaymentContainer}>
                <TickCircleSVG />
                <h3 className={styles.endedPaymentTitle}>
                    This plan has been fully funded and is complete.
                </h3>
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default EndedPaymentPlanView;
